import { render, staticRenderFns } from "./DownloadDocx.vue?vue&type=template&id=51cde57a&"
import script from "./DownloadDocx.vue?vue&type=script&lang=js&"
export * from "./DownloadDocx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports